// extracted by mini-css-extract-plugin
export default {"SaveIssueBanner":"SaveIssueBanner_SaveIssueBanner__Iwni2","text":"SaveIssueBanner_text__U9bGR","dismiss":"SaveIssueBanner_dismiss__EYqXe"};